import React from "react";
import Layout from "@components/layout";
import Seo from "@components/seo";
import BreadCrumb from "@components/common/breadcrumb";
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore/lite";
import { graphql } from "gatsby";
import ContactUs from "@components/common/move-forward";
import CareersScreen from "@screens/careers";
import { useLocation } from "@reach/router";

const Careers = (props) => {
  const app = initializeApp(props?.data?.site?.siteMetadata?.firestore);
  const db = getFirestore(app);
  const breadcrumbLinks = [
    { text: "Home", link: "/" },
    { text: "Careers", link: null },
  ];

  return (
    <Layout db={db}>
      <BreadCrumb items={breadcrumbLinks} />
      <CareersScreen db={db} />
      <ContactUs db={db} />
    </Layout>
  );
};

export const Head = (props) => {
  const { data } = props;
  const location = useLocation();
  return (
    <Seo
      title="Careers | Justtry Technologies"
      metaTitle="Careers | Justtry Technologies"
      description="Discover rewarding career opportunities at [Your Company Name]. Join our dynamic team dedicated to innovation and excellence. Explore diverse roles, growth opportunities, and a supportive work culture. Begin your journey with us today."
      siteFirestore={data?.site?.siteMetadata?.firestore}
      slug={location.pathname.split("/")?.[1]}
    />
  );
};

export default Careers;

export const queryData = graphql`
  query MyQuery {
    site {
      siteMetadata {
        firestore {
          apiKey
          appId
          authDomain
          messagingSenderId
          projectId
          storageBucket
        }
      }
    }
  }
`;
